export default __webpack_public_path__ + "static/phone3-572d49a0b201e016a699533660f4ac2e.png";